import {
  toastr,
  reducer as toastrReducer,
  default as ReduxToastr
} from 'react-redux-toastr';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';

export const success = toastr.success;
export const error = toastr.error;

export const reducer = toastrReducer;
export default ReduxToastr;
